/**Dependencies */
import React, { useState } from "react";
import { infoPlanesXv } from "../helpers";

/**Components */
import { PrincipalBanner } from "../components/PrincipalBanner";
import { SectionOurServices } from "../components/SectionOurServices";
import { Swiper, SwiperSlide } from "swiper/react";
import { Container, Row, Col, Card, Modal, Button } from "react-bootstrap";

/**Styles */
import "../styles/xvAños.scss";

/**Images */
import BannerXv from "../images/banners/banner xv.png";
import iconPlane from "../images/icons/icon-plane.png";
import iconRoom from "../images/icons/icon-room.png";
import iconDinner from "../images/icons/icon-dinner.png";
import iconSafe from "../images/icons/icon-safe-plane.png";
import iconAtractions from "../images/icons/icon-atractions.png";
import imgEuropa1 from "../images/Europa 1.png";
import imgEuropa2 from "../images/Europa 2.png";
import imgEuropa3 from "../images/Europa 3.png";
import imgEuropa4 from "../images/Europa 4.png";
import imgEuropa5 from "../images/Europa 5.png";
import europa5 from "../images/banners/Grupo Europa 5.png";
import imgDubai from "../images/Dubai.png";
import imgFloresUp from "../images/Flores fondo arriba.png";
import imgFloresDown from "../images/Flores fondo abajo.png";
import bannerModal from "../images/banners/Como reservar-xv.png";

export const XvAños = () => {
  const [show, setShow] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeVideo, setActiveVideo] = useState("");

  const handleShow = (content) => {
    setModalContent(infoPlanesXv[content]);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setActiveIndex(0);
  };

  const videos = [
    "https://www.youtube.com/embed/6O2yUdUejJU?si=p1YWI9bvHMlCKX5u?autoplay=1&mute=1",
    "https://www.youtube.com/embed/4LDXpWnOttk?si=0nYEaojzWgnvUh6B?autoplay=1&mute=1",
    "https://www.youtube.com/embed/cFCVFadiMJs?si=xB8QdF0hOHrXgoAv?autoplay=1&mute=1",
  ];

  const openModal = (videoUrl) => {
    setTimeout(() => {
      setActiveVideo(videoUrl); // Establecer el URL del video después de un breve retraso
    }, 100);

    setIsModalOpen(true);
  };

  const closeModal = () => {
    setActiveVideo("");
    setIsModalOpen(false);
  };

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const formatText = (text) => {
    return text.split(",").map((item, index) => (
      <React.Fragment key={index}>
        {item}
        <br />
      </React.Fragment>
    ));
  };

  const icons = [
    { icon: iconPlane },
    { icon: iconRoom },
    { icon: iconDinner },
    { icon: iconSafe },
    { icon: iconAtractions },
  ];

  const destinations = [
    {
      title: "EUROPA 1",
      days: "31 días",
      date: "07 de Julio - 06 de Agosto",
      description: "Conoce: Florencia, Mónaco, Roma, París",
      image: imgEuropa1,
    },
    {
      title: "EUROPA 2",
      days: "26 días",
      date: "14 de Julio - 12 de Agosto",
      description: "Conoce: Londres, Bruselas, Roma, Viena",
      image: imgEuropa2,
    },
    {
      title: "EUROPA 3",
      days: "23 días",
      date: "11 de Julio - 02 de Agosto",
      description: "Conoce: Engelberg, Mónaco, Madrid, Zaragoza",
      image: imgEuropa3,
    },
    {
      title: "EUROPA 4",
      days: "19 días",
      date: "08 de Julio - 06 de Agosto",
      description: "Conoce: Toledo, Venecia, Dubái, Londres",
      image: imgEuropa4,
    },
    {
      title: "EUROPA 5",
      days: "19 días",
      date: "08 de Julio - 06 de Agosto",
      description: "Conoce: Mónaco, Londres, Roma",
      image: imgEuropa5,
    },
    {
      title: "DUBÁI",
      days: "06 días",
      date: "15 de Julio - 20 de Julio",
      description: "Conoce: Dubái y Abu Dabi",
      image: imgDubai,
    },
  ];

  return (
    <div className="xvAños">
      <PrincipalBanner idElemento={9} showSearch={false} />
      <div className="py-5">
        <div className="container-title-xv">
          <Container>
            <p style={{ textAlign: "justify" }}>
              En International Travel Net contamos con el servicio de viajes
              diseñados exclusivamente para quinceañeras, con destinos
              espectaculares en Europa y Dubái. Contamos con personal
              especializado en este tipo de viajes, garantizando experiencias
              inolvidables, combinando diversión, cultura y seguridad.
            </p>
          </Container>
        </div>
        <div className="py-5" style={{ width: "80%", margin: "0 auto" }}>
          <Swiper
            spaceBetween={20}
            slidesPerView={1}
            loop={true}
            autoplay={{ delay: 3000 }}
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
          >
            {videos.map((videoUrl, index) => (
              <SwiperSlide key={index} onClick={() => openModal(videoUrl)}>
                <div
                  style={{
                    position: "relative",
                    cursor: "pointer",
                    width: "100%",
                    height: "35vh",
                  }}
                >
                  <iframe
                    src={videoUrl}
                    title={`Video ${index + 1}`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      top: "0",
                      left: "0",
                      width: "100%",
                      height: "100%",
                    }}
                  ></iframe>

                  {/* Capa invisible para capturar el clic */}
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0)",
                      cursor: "pointer",
                    }}
                  ></div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <Modal show={isModalOpen} onHide={closeModal} size="xl" centered>
            <Modal.Body>
              <div
                style={{
                  position: "relative",
                  paddingBottom: "56.25%",
                  height: "0",
                }}
              >
                {activeVideo && (
                  <iframe
                    src={`${activeVideo}?autoplay=1`}
                    title="Active Video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      width: "100%",
                      height: "100%",
                    }}
                  ></iframe>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn-blue"
                variant="secondary"
                onClick={closeModal}
                style={{ width: "12%", height: "30px", fontSize: "16px" }}
              >
                Cerrar
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
      <div className="py-5">
        <Container className="my-4">
          <Row>
            {destinations.map((dest, index) => (
              <Col key={index} xs={12} md={4} className="mb-4">
                <Card className="destination-card">
                  <div className="image-container">
                    <Card.Img src={dest.image} alt={dest.title} />
                    <div className="title-overlay">
                      <h5>{dest.title}</h5>
                    </div>
                    <div className="info-overlay">
                      <p>
                        <strong>{dest.days}</strong>
                      </p>
                      <p>{dest.date}</p>
                      <p>{dest.description}</p>
                      <Button variant="light" onClick={() => handleShow(index)}>
                        Ver más
                      </Button>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
      <Container className="my-4">
        <Row className="text-center d-flex justify-content-center">
          {icons.map((item, index) => (
            <Col key={index} xs={4} md={2} className="mb-3">
              <div className="icon-container">
                <img
                  src={item.icon}
                  style={{ width: "110px" }}
                  alt={"icons " + index}
                />
              </div>
            </Col>
          ))}
        </Row>
      </Container>
      <div className=" py-5">
        <img
          src={BannerXv}
          style={{
            width: "100%",
            height: "115vh",
            marginBottom: "15px",
            objectFit: "cover",
          }}
          alt="banner campamento"
        />
      </div>
      <div className="py-5">
        <SectionOurServices />
      </div>
      <Modal show={show} onHide={handleClose} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Detalles</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container className="text-center my-4">
            <Row>
              <Col>
                {modalContent && (
                  <>
                    <div
                      style={{
                        backgroundImage: `url("${imgFloresUp}")`,
                        width: "100%",
                        height: "25vh",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                      }}
                    >
                      <h1 className="text-blue" style={{ fontSize: "45px" }}>
                        {modalContent.title}
                      </h1>
                      <h2 className="text-blue" style={{ fontSize: "30px" }}>
                        {modalContent.subtitle}
                      </h2>
                    </div>
                    <img
                      src={europa5}
                      alt="banner europa 5"
                      style={{ width: "100%" }}
                    />

                    <div className="d-flex justify-content-start py-5 container">
                      <h3 className="text-blue" style={{ fontSize: "25px" }}>
                        {modalContent.day}
                      </h3>
                    </div>

                    <div className="accordion-xv container py-5">
                      {modalContent.itinerary.map((item, index) => (
                        <div key={index} className="accordion-item">
                          <div
                            className={`accordion-header ${
                              activeIndex === index ? "active" : ""
                            }`}
                            onClick={() => toggleAccordion(index)}
                          >
                            <h3>{item.nameTab}</h3>
                            <span>{activeIndex === index ? "▲" : "▼"}</span>
                          </div>
                          {activeIndex === index && (
                            <div className="accordion-body">
                              {item.location !== "" && (
                                <span>{item.location}</span>
                              )}

                              <br />

                              {index === 0 || index === 1
                                ? formatText(item.activitie)
                                : item.activitie}
                            </div>
                          )}
                        </div>
                      ))}
                      <div
                        style={{
                          backgroundImage: `url("${imgFloresDown}")`,
                          width: "100%",
                          height: "17vh",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      ></div>
                    </div>
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        height: "300px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={bannerModal}
                        alt="Banner"
                        style={{ width: "100%", height: "100%" }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: "20px",
                          transform: "translateY(-50%)",
                        }}
                      >
                        <a
                          href="tel:+7772035097"
                          style={{ fontSize: "17px", color: "white" }}
                        >
                          <Button
                            className="btn-blue"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "10px 20px",
                              fontSize: "1.7rem",
                            }}
                          >
                            {" "}
                            777 203 5097{" "}
                          </Button>
                        </a>
                      </div>
                    </div>
                  </>
                )}
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn-blue"
            onClick={handleClose}
            style={{ width: "12%", height: "30px", fontSize: "15px" }}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
